exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.index .economy-overview {\n  background: #172b43;\n  margin-bottom: 60px;\n  margin-bottom: 45px;\n  padding: 30px;\n  border-radius: 3px;\n  text-align: center;\n  box-shadow: 0 5px 15px rgba(40, 60, 134, 0.15);\n  color: #fff;\n}\n.index .economy-overview [class^=\"col-\"]:nth-of-type(2) {\n    border-left: 1px solid #244369;\n    border-right: 1px solid #244369;\n}\n.index .economy-overview [class^=\"col-\"] .text {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 7.5px;\n}\n.index .economy-overview [class^=\"col-\"] .number {\n    font-size: 36px;\n    font-weight: 700;\n    font-family: \"Montserrat\", sans-serif;\n}\n.index .number-overview {\n  margin-bottom: 60px;\n  margin-bottom: 30px;\n}\n.index .tables-overview {\n  margin-bottom: 60px;\n  margin-bottom: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7dd1bf60","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/index/index.vue
// module id = 581
// module chunks = 0